import { useIntl } from 'react-intl';
import { FlagIcon } from 'sonata-platform-components';
import { normalize } from 'sonata-static-storage/lib/helpers/i18nUnits.helpers';

import type { ScreenInventoryVolumetry } from 'sonata-static-storage/lib/common/common.types';

type Props = {
  volumetry: ScreenInventoryVolumetry;
};

type ItemProps = {
  countryCode: string;
};

function CountryVolumetryItem({ countryCode }: Readonly<ItemProps>) {
  return (
    <div className="doohInventoryMapVolumetry__metric">
      <span className="doohInventoryMapVolumetry__metricValue">
        <FlagIcon country={countryCode} id={`countryIcon-${countryCode}`} shape="circle" />
      </span>
      <span className="doohInventoryMapVolumetry__metricName">{countryCode.toUpperCase()}</span>
    </div>
  );
}

export default function CountryVolumetry({ volumetry }: Readonly<Props>) {
  const MAX_LENGHT_NUMBER_OF_COUNTRIES_TO_SHOW = 4;
  const { formatMessage } = useIntl();
  if (volumetry.countries <= MAX_LENGHT_NUMBER_OF_COUNTRIES_TO_SHOW) {
    return volumetry.countryCodes.map(countryCode => (
      <CountryVolumetryItem countryCode={countryCode} key={`countryVolumetry-${countryCode}`} />
    ));
  }

  return (
    <div className="countryVolumetry doohInventoryMapVolumetry__metric">
      <span className="doohInventoryMapVolumetry__metricValue">
        <span>+</span>
        {normalize(volumetry.countries, 0, 'es')}
      </span>
      <span className="doohInventoryMapVolumetry__metricName">
        {formatMessage({
          defaultMessage: 'Countries',
          id: 'doohInventory.volumetry.countries'
        })}
      </span>
    </div>
  );
}
